var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',[_c('link',{attrs:{"href":_vm.appCss,"rel":"stylesheet"}}),_c('div',{ref:"widgetAlarm",staticClass:"portailAutonome-alarm",attrs:{"data-project":this.$store.state.user.client.onconnectname,"data-length":_vm.pdsList.length,"data-lang":this.$store.state.lang.lang}})])
}
var staticRenderFns = []

export { render, staticRenderFns }